import { ORDERS_STATUS } from './constant';

export function capitalizeFirstLetter(value: string | null | undefined) {
  if (value == null) return '';
  const str = String(value);
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function stringReduceAddDots(string: string, limit: number) {
  if (String(string).length <= limit) {
    return string;
  } else {
    return `${String(string).slice(0, limit)}...`;
  }
}

export function formatLocation(inputString: string) {
  var parts = inputString.split(', ');

  if (parts.length >= 2) {
    return parts[1] + ', ' + parts[2];
  } else {
    return inputString; // Return the original string if it cannot be split as expected
  }
}

export function tabValue(status: string) {
  let resut = 'NEW';
  switch (status) {
    case ORDERS_STATUS.NEW:
      resut = 'new';
      break;
    case ORDERS_STATUS.VALIDATED_BY_RESTO:
      resut = 'new';
      break;
    case ORDERS_STATUS.PREPARING:
      resut = 'preparing';
      break;
    case ORDERS_STATUS.ONROUTE:
      resut = 'onDelivery';
      break;
    case ORDERS_STATUS.READY:
      resut = 'ready';
      break;
    case ORDERS_STATUS.DELIVERED:
      resut = 'delivered';
      break;

    default:
      break;
  }

  return resut;
}

export function nextStatus(status: string) {
  let resut = status;
  switch (status) {
    case ORDERS_STATUS.NEW:
      resut = 'VALIDATED_BY_RESTO';
      break;
    case ORDERS_STATUS.PREPARING:
      resut = 'READY';
      break;
    default:
      break;
  }

  return resut;
}

const generateKeywordsByName = (name: string) => {
  let keywords = [] as string[];
  const letters = name.split('');
  letters.reduce((previous, current) => {
    previous += current;
    keywords.push(previous);
    return previous;
  }, '');

  return keywords.map((keyword) => keyword.toLowerCase());
};

export const generateKeywordsByNames = (name: string) => {
  let keywords = [] as string[];
  let words = name.split(' ');
  for (const word of words) {
    let ret = generateKeywordsByName(word);
    keywords = keywords.concat(ret);
  }

  words.reduce((previous, current) => {
    if (previous !== '') {
      previous += ' ' + current;
      let result = generateKeywordsByName(previous);
      keywords = keywords.concat(result);
      return previous;
    }
    return current;
  }, '');

  return [...(new Set(keywords) as any)];
};

export function getTimestampOfPreviousWeekday(): number {
  const currentDate = new Date();
  let daysToSubtract = 0;

  switch (currentDate.getDay()) {
    case 0:
      daysToSubtract = 2;
      break;
    case 1:
      daysToSubtract = 3;
      break;
    case 2:
      daysToSubtract = 4;
      break;
    case 3:
      daysToSubtract = 5;
      break;
    case 4:
      daysToSubtract = 6;
      break;
    case 5:
      daysToSubtract = 0;
      break;
    case 6:
      daysToSubtract = 1;
      break;
  }

  // Calculate the timestamp of the previous weekday
  const previousWeekdayTimestamp =
    currentDate.getTime() - daysToSubtract * 24 * 60 * 60 * 1000;

  return previousWeekdayTimestamp;
}

export function calculateAverageRating(ratings: {
  [key: string]: number;
}): number {
  let sum = 0;
  let count = 0;

  for (const key in ratings) {
    // eslint-disable-next-line no-prototype-builtins
    if (ratings.hasOwnProperty(key)) {
      sum += parseInt(key) * ratings[key];
      count += ratings[key];
    }
  }

  if (count === 0) {
    return 0;
  } else {
    return sum / count;
  }
}

export function calculRestauRating(ratings: { [key: string]: number }): number {
  let sum = 0;
  let count = 0;

  for (const key in ratings) {
    // eslint-disable-next-line no-prototype-builtins
    if (ratings.hasOwnProperty(key)) {
      sum += parseInt(key) * ratings[key];
      count += ratings[key];
    }
  }

  if (count === 0) {
    return 0;
  } else {
    return sum;
  }
}

export const checkEmail = (email: string): boolean => {
  const emailRegex: RegExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return emailRegex.test(email);
};

export const calculateArticlesTotal = (item: any) => {
  if (!item.items.length) {
    return 0;
  }
  return item.items
    ?.filter((el: any) => el?.cancelled === false)
    ?.reduce(
      (acc: any, cur: any) =>
        acc +
        (cur?.price +
          cur?.complementPrice +
          cur?.extras?.reduce(
            (accu: any, curr: any) =>
              accu + Number(curr.price) * Number(curr?.quantity),
            0
          )) *
          cur?.quantity,
      0
    )
    .toLocaleString();
};
